import { FC, useEffect } from 'react';
import { P, Span } from 'atoms/Typography';
import { useTimer } from './hooks/useTimer';
import { setBannerTime } from './services';
import styles from './styles.module.css';

export const Timer: FC<{
  timer: string;
  _uid: string;
  isValid: boolean;
}> = ({ _uid, timer, isValid }) => {
  const { minutes, seconds, startTimer, stopTimer, timerState } = useTimer(
    parseInt(timer),
    _uid,
  );

  const disableTimer = () => {
    setBannerTime(_uid, 0);
    stopTimer();
  };

  useEffect(() => {
    if (!isValid) {
      disableTimer();
    }

    return () => stopTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!timerState.isRunning && !!timerState.time && isValid) {
      startTimer();
    }

    if (!isValid) {
      disableTimer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerState]);

  return !timerState.isRunning ? null : (
    <P className={styles.timer}>
      <Span className={styles.minutes}>{minutes}</Span>:
      <Span className={styles.seconds}>{seconds}</Span>
    </P>
  );
};
